import conn from "@/flit2go-web-core/services/connection";

export default {
  getOwnerById(id) {
    return conn.$axios({
      url: `/secured/v1.2/owner/${id}`,
      method: "GET",
    });
  },
  getOwnerByIdV1(id) {
    return conn.$axios({
      url: `/secured/v1/owner/${id}`,
      method: "GET",
    });
  },
  getOwnerWithoutPerms(id) {
    return conn.$axios({
      url: `/secured/v1/owner/${id}/special`,
      method: "GET",
    });
  },
  getSubOwners(params) {
    return conn.$axios({
      url: `/secured/v1/superOwner/search`,
      method: "GET",
      params: params,
    });
  },
  hasExternalStripe(params) {
    return conn.$axios({
      url: `/secured/v1/owner/external_stripe`,
      method: "GET",
      params: params,
    });
  },
  getOwners(params) {
    return conn.$axios({
      url: `/secured/v1/owner/search`,
      method: "GET",
      params: params,
    });
  },
  getOwnersList(params) {
    return conn.$axios({
      url: `/secured/v1/owner/search`,
      method: "GET",
      params: params,
    });
  },
  getOwnerBilling(ownerId) {
    return conn.$axios({
      url: `/secured/v1/owner/${ownerId}/billing/settings`,
      method: "GET",
    });
  },
  updateOwnerBilling(data) {
    return conn.$axios({
      url: `/secured/v1/owner/${data.ownerId}/billing/settings`,
      method: "PUT",
      data: data.params,
    });
  },
  checkSII(ownerId) {
    return conn.$axios({
      url: `/secured/v1/check/sii/${ownerId}`,
      method: "GET",
    });
  },
  getPossibleCurrencies(ownerId) {
    return conn.$axios({
      url: `/secured/v1/owner/currencies/${ownerId}`,
      method: "GET",
    });
  },
};
